import { useEffect } from "react"
import { Input, Form, Button, message } from "antd"
import { useGlobalContext } from "../../context/provider"
import { AxiosPostData } from "../../context/axiosfunction"
import { getLocalStorage, removeLocalStorage, setLocalStorage } from "@/lib/localStorage"
import CryptoJS from "crypto-js"
import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import liff from '@line/liff';

const Login = () => {
    const { setTypeLogin, theme, API, privateKey, headers, setToken, FACEBOOK_CLIENT_ID, GOOGLE_CLIENT_ID, refreshCart } = useGlobalContext()
    const [FormLogin] = Form.useForm()
    const [messageApi, contextHolder] = message.useMessage()

    const SendData = async (data) => {

        const cart = getLocalStorage('Cart')

        const logindata = {
            username: data.username,
            password: data.password,
            cart: cart ? cart.value : null
        }

        try {
            const Login = await AxiosPostData(API, '/api/login', logindata, privateKey)

            if (Login.status === 'success') {
                messageApi.open({
                    type: 'success',
                    content: 'กำลังเข้าสู่ระบบ...'
                })

                const datares = Login.data;
                const token = datares.Token || '';
                const cart = datares.cart ? datares.cart : null;
                const user_shalve = datares.user_shalve ? datares.user_shalve : null;
                const noti_user = datares.noti || 0
                const user_preorder = datares.user_preorder ? datares.user_preorder : null;
                localStorage.setItem('Noti', noti_user)

                let shalve = [];
                let preorder = [];
                // let noti = 0
                if (user_shalve) {
                    shalve = JSON.parse(user_shalve);
                }

                if (user_preorder) {
                    preorder = JSON.parse(user_preorder);
                }

                if (cart) {
                    const bytes = CryptoJS.AES.decrypt(cart, privateKey);
                    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
                    const cartDB = JSON.parse(decrypted);
                    // console.log(cartDB);

                    const Localcart = getLocalStorage('Cart')
                    if (Localcart) {
                        const localcartdecrpyt = CryptoJS.AES.decrypt(Localcart.value, privateKey);
                        const decryptedlocal = localcartdecrpyt.toString(CryptoJS.enc.Utf8);

                        const cartLocal = JSON.parse(decryptedlocal);

                        const merged = [
                            ...cartDB,
                            ...cartLocal?.filter(item2 => !cartDB.some(item1 => item1.book_series_id === item2.book_series_id) &&
                                !shalve.includes(item2.book_series_id)),
                        ];

                        const encrypt = CryptoJS.AES.encrypt(JSON.stringify(merged), privateKey).toString();
                        setLocalStorage('Cart', { value: encrypt })
                    } else {
                        setLocalStorage('Cart', { value: cart });
                    }
                } else {

                    const Localcart = getLocalStorage('Cart')

                    if (Localcart) {
                        const localcartdecrpyt = CryptoJS.AES.decrypt(Localcart.value, privateKey);
                        const decryptedlocal = localcartdecrpyt.toString(CryptoJS.enc.Utf8);

                        const cartLocal = JSON.parse(decryptedlocal);

                        const merged = [
                            ...cartLocal?.filter(item2 => !shalve.includes(item2.book_series_id)),
                        ];

                        const encrypt = CryptoJS.AES.encrypt(JSON.stringify(merged), privateKey).toString();
                        setLocalStorage('Cart', { value: encrypt })
                    }
                }
                localStorage.setItem('Token', token);
                setToken(token)
                setLocalStorage('Shalve', user_shalve)
                setLocalStorage('Preorder', user_preorder)
                return setTimeout(() => {
                    window.location.reload();
                }, 300);
            } else {
                return messageApi.open({
                    type: 'error',
                    content: Login.message
                })
            }


        } catch (error) {
            console.log(error);

            return messageApi.open({
                type: 'error',
                content: 'เกิดข้อผิดพลาดกรุณารอการแก้ไข'
            })
        }
    }

    const MyGoogleLoginButton = () => {
        const login = useGoogleLogin({
            onSuccess: async (tokenResponse) => {

                try {
                    // ใช้ Google API เพื่อดึงข้อมูลโปรไฟล์
                    const response = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
                        headers: {
                            Authorization: `Bearer ${tokenResponse.access_token}`,
                        },
                    });

                    const data = await response.json();

                    // console.log("User Info:", data);

                    // ได้ค่า email และ name
                    const email = data.email;
                    const name = data.name;

                    handleGoogleResponse(email, name, 'google');
                } catch (error) {
                    console.error("Error fetching user info:", error);
                }

            },
            onError: () => {
                messageApi.open({
                    type: 'error',
                    content: 'เกิดข้อผิดพลาดในการดึงข้อมูลจาก facebook'
                });
            },
            ux_mode: "popup",
            redirect_uri: window.location.origin
        });

        return (
            <button className="cursor-pointer" type="button" onClick={() => login()}>
                <img className="h-[32px]" src="https://eve-image.eveebook.com/image.eveebook/web_image/new_gg.png" alt="gmail" />
            </button>
        );
    };

    const facebookLogin = (onLoginSuccess) => {
        window.FB.login((response) => {
            if (response.authResponse) {
                const accessToken = response.authResponse.accessToken;

                window.FB.api(
                    '/me',
                    {
                        fields: 'name,email',
                        access_token: accessToken, // ✅ แก้ไขตรงนี้เท่านั้น
                    },
                    (userInfo) => {
                        onLoginSuccess(userInfo.email, userInfo.name);
                        handleGoogleResponse(userInfo.email, userInfo.name, 'facebook');
                    }
                );
            }
        }, { scope: 'email' });
    };



    const FacebookLoginButton = () => {


        const handleLogin = () => {
            facebookLogin((email, name) => {
            });
        };

        return (
            <button type="button" className="cursor-pointer" onClick={handleLogin}>
                <img className="h-[32px]" src="https://eve-image.eveebook.com/image.eveebook/web_image/new_fb.png" alt="gmail" />
            </button>
        );
    };

    const Linelogin = async () => {
        try {
            await liff.init({ liffId: process.env.NEXT_PUBLIC_LIFF_ID });
            liff.login();
        } catch (err) {
        }
    }

    const handleGoogleResponse = async (email, name, type) => {

        const cart = getLocalStorage('Cart')
        // console.log(cart);


        const DataGG = {
            username: name,
            useremail: email,
            platform: type,
            cart: cart ? cart.value : null
        }

        try {
            const response = await AxiosPostData(API, '/api/login_social', DataGG, headers)

            // console.log(response);

            if (response.status === 'success') {
                messageApi.open({
                    type: 'success',
                    content: response.message
                });
                localStorage.setItem("Token", response.data.Token)
                const cart = response.data.cart ? response.data.cart : null;
                const user_shalve = response.data.user_shalve ? response.data.user_shalve : null;
                const user_preorder = response.data.user_preorder ? response.data.user_preorder : null;
                let shalve = [];
                let preorder = [];

                if (user_shalve) {
                    shalve = JSON.parse(user_shalve);
                }
                if (user_preorder) {
                    preorder = JSON.parse(user_preorder);
                }

                if (cart) {

                    const bytes = CryptoJS.AES.decrypt(cart, privateKey);
                    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
                    const cartDB = JSON.parse(decrypted);
                    // console.log(cartDB); 

                    const Localcart = getLocalStorage('Cart')
                    if (Localcart) {
                        const localcartdecrpyt = CryptoJS.AES.decrypt(Localcart.value, privateKey);
                        const decryptedlocal = localcartdecrpyt.toString(CryptoJS.enc.Utf8);

                        const cartLocal = JSON.parse(decryptedlocal);

                        const merged = [
                            ...cartDB,
                            ...cartLocal?.filter(item2 => !cartDB.some(item1 => item1.book_series_id === item2.book_series_id) &&
                                !shalve.includes(item2.book_series_id)),
                        ];
                        // console.log(merged);

                        const encrypt = CryptoJS.AES.encrypt(JSON.stringify(merged), privateKey).toString();
                        setLocalStorage('Cart', { value: encrypt })
                    } else {
                        setLocalStorage('Cart', { value: cart });
                    }
                } else {

                    const Localcart = getLocalStorage('Cart')

                    if (Localcart) {
                        const localcartdecrpyt = CryptoJS.AES.decrypt(Localcart.value, privateKey);
                        const decryptedlocal = localcartdecrpyt.toString(CryptoJS.enc.Utf8);

                        const cartLocal = JSON.parse(decryptedlocal);

                        const merged = [
                            ...cartLocal?.filter(item2 => !shalve.includes(item2.book_series_id)),
                        ];
                        // console.log(merged);

                        const encrypt = CryptoJS.AES.encrypt(JSON.stringify(merged), privateKey).toString();
                        setLocalStorage('Cart', { value: encrypt })
                    }
                }

                setLocalStorage('Shalve', user_shalve)
                setLocalStorage('Preorder', user_preorder)

                setTimeout(() => {
                    window.location.reload()
                }, 1000)

            } else {
                messageApi.open({
                    type: 'error',
                    content: response.message
                });
            }


        } catch (error) {
            console.log(error);

            messageApi.open({
                type: 'error',
                content: 'เกิดข้อผิดพลาดในการดึงข้อมูล'
            });

        }
    };

    return (
        <div className="flex flex-col items-center gap-[16px] pt-[82px] h-full">
            {contextHolder}
            {theme === 'light_theme' ? <img className="mb-[30px] w-[106px]" src="https://eve-image.eveebook.com/image.eveebook/web_image/EVElogo.png" alt="logo" /> : <img className="mb-[30px] w-[106px]" src="https://eve-image.eveebook.com/image.eveebook/web_image/EVELogoWhite.png" alt="logo" />}
            <Form autoComplete="off" onFinish={SendData} form={FormLogin} className="w-[90%] md:w-[70%] xl:w-[60%] flex flex-col md:gap-[25px]">
                <Form.Item name="username" layout="vertical" label={<span className="text-[16px]  text-primary "  >ชื่อผู้ใช้หรืออีเมล</span>} className="md:flex md:flex-col ">
                    <Input placeholder="ชื่อผู้ใช้หรืออีเมล" className="rounded-full h-[40px]" />
                </Form.Item>
                <Form.Item name="password" layout="vertical" label={<span className="text-[16px]  text-primary">รหัสผ่าน</span>} className="md:flex md:flex-col ">
                    <Input placeholder="************" className="rounded-full h-[40px]" type="password" />
                </Form.Item>
                <Form.Item className="mt-[24px]  mb-0">
                    <Button htmlType="submit" style={{ borderRadius: '40px' }} className="w-full  h-[40px] btn-primary">เข้าสู่ระบบ</Button>
                </Form.Item>
            </Form>

            <div style={{ fontFamily: 'Noto Sans Thai', color: '#C4C4C4' }}>หรือ</div>
            <div className="flex gap-[24px]">
                <button onClick={Linelogin} className="cursor-pointer" type="button">
                    <img className="h-[32px]" src="https://eve-image.eveebook.com/image.eveebook/web_image/new_line.png" alt="line" />
                </button>
                <MyGoogleLoginButton />
                <FacebookLoginButton />
            </div>
            <div className="flex justify-between items-end h-full w-[60%] pb-[46px]">
                <span className="text-disable">ยังไม่มีบัญชีใช่ไหม?</span>
                <button onClick={() => setTypeLogin('regis')} type="button" className="text-special cursor-pointer">สมัครสมาชิก</button>
            </div>
        </div>
    )
}

export default Login